module.exports = __webpack_public_path__ + "static/img/gate-wall_256.501b632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gate-wall_256.png
// module id = scBL
// module chunks = 0